module["exports"] = [
  "Burgenland",
  "Kärnten",
  "Niederösterreich",
  "Oberösterreich",
  "Salzburg",
  "Steiermark",
  "Tirol",
  "Vorarlberg",
  "Wien"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_AT/address/state.js
// module id = 380
// module chunks = 0